import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Button, NotYetImplemented } from '../../components/ui';
import DescribeBox from '../home/DescribeBox';
import TaskCard from '../home/TaskCard';
import { useSavedTasks } from './useSavedTasks';

export default function TasksPage() {
  const { loading, error, tasks, reload } = useSavedTasks();
  const [text, setText] = useState('');
  const [deleted, setDeleted] = useState([]);
  const visible = tasks.filter((t) => !deleted.includes(t.id));

  return (
    <div className="bg-paper text-ink min-h-full">
      <div className="max-w-6xl mx-auto px-6 py-9 flex flex-col gap-9">
        <h1 className="font-display text-4xl font-extrabold tracking-tight">Tasks</h1>

        <DescribeBox
          value={text}
          onChange={setText}
          label="New task"
          placeholder="Describe what you need done — we'll plan the steps"
        />

        <section>
          <div className="flex items-baseline justify-between mb-3.5 gap-3 flex-wrap">
            <h2 className="font-display text-2xl font-extrabold">Your tasks</h2>
            {!loading && !error && <span className="text-sm text-pencil">{visible.length} saved</span>}
          </div>
          {loading ? null : error ? (
            <div className="flex items-center gap-3">
              <p role="alert" className="text-status-failed">Couldn't load your tasks.</p>
              <Button variant="secondary" size="sm" onClick={reload}>Try again</Button>
            </div>
          ) : visible.length === 0 ? (
            <p className="text-pencil">No saved tasks yet.</p>
          ) : (
            <div className="grid gap-[18px] sm:grid-cols-2 lg:grid-cols-3">
              {visible.map((t) => (
                <TaskCard key={t.id} task={t} onDeleted={(id) => setDeleted((d) => [...d, id])} />
              ))}
            </div>
          )}
        </section>

        <section>
          <NotYetImplemented feature="orgPublic">
            <h2 className="font-display text-2xl font-extrabold">Public in your organisation</h2>
          </NotYetImplemented>
        </section>
      </div>
    </div>
  );
}

/** Element for /tasks: old ?template= and ?describe= links go to their new homes. */
export function TasksRoute() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const template = params.get('template');
  if (template) return <Navigate to={`/tasks/${encodeURIComponent(template)}`} replace />;
  if (params.has('describe')) return <Navigate to={{ pathname: '/tasks/new', search }} replace />;
  return <TasksPage />;
}
